import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {HelpersService} from '../../../../core/services/helpers.service';
import {FileFolders} from '../../fascicolo/documentazione-allegata-view/documentazione-allegata.component';
import {DocumentoAllegato} from '../../../models/documento-allegato';
import {ModalNotifyService} from '../../../../core/services/modal-notify.service';
import {Subscription} from 'rxjs';
import {OperationsService} from '../../../../core/services/operations.service';

@Component({
  selector: 'app-detail-folder-file-option',
  templateUrl: './detail-folder-file-option.component.html',
  styleUrls: ['./detail-folder-file-option.component.css']
})
export class DetailFolderFileOptionComponent implements OnInit {

  @Input()
  item: FileFolders;

  @Output()
  onClickRemoveDocument = new EventEmitter<FileFolders>();

  constructor(
    private helpersService: HelpersService,
    private operationsService: OperationsService
  ) {
  }

  ngOnInit() {}

  removeDocument() {
    this.onClickRemoveDocument.emit(this.item);
  }
}
